import store from '../store'

const baseUrlLocal = {
  'Mrin': '/dev-api-mrin',
  'Printmaster': '/dev-api-printmaster',
  'LabelMaster': '/dev-api-labelmaster',
  'XBManager': '/dev-api-xbmanager',
  'Phocol': '/dev-api-phocol',
}
const baseUrlDev = {
  'Mrin': 'https://api-test.qu-in.com',
  'Printmaster': 'https://api-test.labelmaster.qu-in.com',
  'LabelMaster': 'https://api-test.labelmaster.qu-in.com',
  'XBManager': 'https://api-test.tobacco.qu-in.com',
  'Phocol': 'http://test-api.phocolprinter.com',
}
const baseUrlProd = {
  'Mrin': 'https://api.qu-in.com',
  'Printmaster': 'https://api.qu-in.top',
  'LabelMaster': 'https://api.qu-in.top',
  'XBManager': 'https://api.tobacco.qu-in.com',
  'Phocol': 'http://cnapi.phocolprinter.com',
}

/**
 * 计算str的字节长度
 */
export const getStrBytesLength = (str) => {
   let count = 0
   const arr = str.split('')
   arr.forEach(item => {
     count += Math.ceil(item.charCodeAt().toString(2).length / 8)
   })
   return count
  }
  

export function randomSortArray(arr) {
  const stack = []
  while (arr.length) {
    //Math.random()：返回 [0,1) 之间的一个随机数
    const index = parseInt(Math.random() * arr.length);  // 利用数组长度生成随机索引值
    stack.push(arr[index]);  // 将随机索引对应的数组元素添加到新的数组中
    arr.splice(index, 1);  // 删除原数组中随机生成的元素
  }
  return stack;
}

function getBaseUrl () {
  const platform = store.state.platform
  if ([
    'Mrin', 'Printmaster', 'LabelMaster', 'XBManager', 'Phocol'
  ].indexOf(platform) !== -1
  ) {
    const baseUrl = process.env.NODE_ENV === 'development'
      ? baseUrlLocal[platform]
      // ? 'https://api-test.qu-in.com'
      : window.location.host.indexOf('downloadapp-test.qu-in.com') >= 0
        ? baseUrlDev[platform]
        : window.location.host.indexOf('static-mp-3ad9d062-6b2f-492c-942f-5499fda6614c.next.bspapp.com') >= 0
          ? baseUrlDev[platform]
          : baseUrlProd[platform]
    return baseUrl
  } else {
    return ''
  }
}

export function postRequest (url, data, headers) {
  return new Promise((resolve, reject) => {
    const baseUrl = getBaseUrl()
    if (baseUrl) {
      let _data = undefined
      const xhr = new XMLHttpRequest()
      xhr.open('POST', `${baseUrl}${url}`)
      
      if (headers && typeof headers === 'object') {
        Object.entries(headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value)
        })
      }
      if (data instanceof FormData) {
        // xhr.setRequestHeader('Content-Type', 'application/form-data')
        _data = data
      } else if (data instanceof Object) {
        xhr.setRequestHeader('Content-Type', 'application/json')
        _data = JSON.stringify(data)
      }
      
      xhr.responseType = 'json'
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          resolve(xhr.response)
        }
      }
      
      // const formData = new FormData()
      // Object.entries(data).forEach(([key, value]) => {
      //   formData.append(key, value)
      // })
      
      // xhr.send(formData)
          
      xhr.send(_data)
    } else {
      reject(false)
    }
  })
}

export function getRequest (url, params, headers) {
  return new Promise((resolve, reject) => {
    const baseUrl = getBaseUrl()
    if (baseUrl) {
      const queryArr = []
      if (params && typeof params === 'object') {
        Object.entries(params).forEach(([key, value]) => {
          queryArr.push(`${key}=${encodeURIComponent(value)}`)
        })
      }
      const queryStr = queryArr.join('&')
      const _url = queryStr ? `${url}?${queryStr}` : url
      const xhr = new XMLHttpRequest()
      
      xhr.open('GET', `${baseUrl}${_url}`)
      
      if (headers && typeof headers === 'object') {
        Object.entries(headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value)
        })
      }
      
      xhr.responseType = 'json'
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          resolve(xhr.response)
        }
      }
          
      xhr.send()
    } else {
      reject(false)
    }
  })
}

/**
 * rem布局，根据页面大小确定基础font-size
 * 1rem = 1 documentFontSize = 100px (1920px screen width)
 */
export function initRemSize () {
  let clientWidth = document.documentElement.clientWidth,
      clientHeight = document.documentElement.clientHeight
  if (clientWidth / clientHeight > 1) {
    if (clientWidth <= 1920) {
      document.documentElement.style.fontSize = ((document.documentElement.clientWidth / 19.2) + 0) + 'px'
    } else if (clientWidth > 1920 && clientWidth <= 2160) {
      document.documentElement.style.fontSize = ((document.documentElement.clientWidth / 19.2) + 0) + 'px'
    } else {
      document.documentElement.style.fontSize = ((document.documentElement.clientWidth / 19.2) + 0) + 'px'
    }
  } else {
    document.documentElement.style.fontSize = ((document.documentElement.clientWidth / 7.5)) + 'px'
  }
}
